import { COURIER_IDS, type CourierId } from '../ids/ids';

/**
 * Мини-игры второго шанса по курьеру (GDD «Мини-игры персонажей»).
 * Ровно одна игра на курьера.
 */
export const COURIER_MINIGAMES = {
  eddy: ['eddy_lucky_shot'],
  claudi: ['claudi_find_pairs'],
  tuchi: ['tuchi_melody'],
  ufo: ['ufo_decipher_words'],
  vall: ['vall_drop_box'],
  rock: ['rock_rotate_puzzle'],
} as const satisfies Record<CourierId, readonly string[]>;

export type MinigameId = (typeof COURIER_MINIGAMES)[CourierId][number];

export const ALL_MINIGAME_IDS: MinigameId[] = Array.from(
  new Set(COURIER_IDS.flatMap((c) => [...COURIER_MINIGAMES[c]])),
) as MinigameId[];

export function getMinigamesForCourier(courierId: CourierId): readonly MinigameId[] {
  return COURIER_MINIGAMES[courierId];
}

/** Единственная мини-игра второго шанса для курьера. */
export function getSecondChanceMinigameId(courierId: CourierId): MinigameId {
  return COURIER_MINIGAMES[courierId][0];
}

export function isMinigameId(value: string): value is MinigameId {
  return (ALL_MINIGAME_IDS as readonly string[]).includes(value);
}

export function isMinigameAllowedForCourier(
  courierId: CourierId,
  minigameId: MinigameId,
): boolean {
  return (COURIER_MINIGAMES[courierId] as readonly string[]).includes(minigameId);
}
